module.exports = __webpack_public_path__ + "static/websites2-e652c66095dac402aa75ebde7fde3e41.jpg";